/* eslint-disable no-underscore-dangle */

function UIProgressMeter() {
  const elem = document.createElement('DIV');
  elem.innerHTML = '<div data-component="progressmeter"><label></label></div>';

  this.__hostElement = elem.children[0];
  this.__label = this.__hostElement.querySelector('label');
}
UIProgressMeter.prototype = {
  getHostElement: function() {
    return this.__hostElement;
  },

  getLabel: function() {
    return this.__label.textContent;
  },

  setLabel: function(label) {
    this.__label.textContent = label;
  }
};

module.exports = UIProgressMeter;
